import React from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage} from 'react-intl';

const About = ({className = '', description}) => {
  return (
    <div className={`w-80-ns w-100 ${className}`}>
      <div className="tr-ns tc mb5">
        <h5 className="f4 mb3">
          <FormattedMessage id="about_course" />
        </h5>
        <p
          className="f5 gray"
          dangerouslySetInnerHTML={{__html: description}}
        />
      </div>
    </div>
  );
};

About.propTypes = {
  className: PropTypes.string,
  description: PropTypes.string,
};

export default About;
